import { ELang, IAppState } from "../interfaces/app.state";
import i18n from "@/i18n.ts";

const initAppState: IAppState = {
  popup: {
    isOpen: false,
    name: "",
    data: null
  },
  currentLang: ELang.de,
  isRequestError: false,
  isFontLoad: false,
  isLangDetected: false,
  cookieOpen: false
};

export default {
  namespaced: true,
  state: initAppState,
  actions: {
    togglePopupAction({ commit }, param) {
      commit("togglePopup", param);
    },
    setCurrentLang({ commit }, lang) {
      if (lang === "styleguide") return;
      commit("setCurrentLang", lang);
    },
    setLangDetected({ commit }) {
      commit("setLangDetected");
    },
    setFontLoad({ commit }) {
      commit("setFontLoad");
    },
    showRequestError({ commit }, isShow: boolean = true) {
      commit("showRequestError", isShow);
    },
    toggleCookie({ commit }, cookie: boolean) {
      commit("setCookie", cookie);
    }
  },
  mutations: {
    togglePopup(state: IAppState, param) {
      if (param) {
        state.popup = Object.assign(state.popup, param, { isOpen: true });
      } else {
        state.popup = {
          isOpen: false,
          name: "",
          data: null
        };
      }
    },
    setCurrentLang(state: IAppState, lang) {
      const locales = ["de", "us", "uk", "br", "es", "it", "nl", "fr"];
      if (locales.includes(lang)) {
        localStorage.setItem("currentLang", lang);
        i18n.locale = lang;
        state.currentLang = lang;
        document.getElementsByTagName("html")[0].lang = lang;
      }
    },
    setLangDetected(state: IAppState) {
      state.isLangDetected = true;
    },
    setFontLoad(state: IAppState) {
      state.isFontLoad = true;
    },
    showRequestError(state: IAppState, isShow) {
      state.isRequestError = isShow;
    },
    setCookie(state: IAppState, cookie) {
      state.cookieOpen = cookie;
    }
  },
  getters: {
    app: state => state,
    popup: (state: IAppState) => state.popup,
    lang: (state: IAppState) => {
      return state.currentLang;
    },
    isFontLoad: (state: IAppState) => state.isFontLoad,
    isLangDetected: (state: IAppState) => state.isLangDetected,
    isRequestError: (state: IAppState) => state.isRequestError,
    getCookie: (state: IAppState) => state.cookieOpen
  }
};
